exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-zoom-carousel .VueCarousel-wrapper,.media-zoom-carousel .VueCarousel-inner,.media-zoom-carousel .VueCarousel-slide{height:100%}", ""]);

// exports
